import React, { useState } from 'react';
import AppStatusView from './AppStatusView';
import useAppStatusLogic from './AppStatusLogic';

/**
 * Application Status Page
 * Shows the deployment and deployment process status
 * Connects the logic hook with the view component
 */
const AppStatusPage = () => {
  // State for controlling secondary processes like starting substeps
  const [startSubstepsLoading, setStartSubstepsLoading] = useState(false);
  
  // Use the logic hook that centralizes all functionality
  const {
    fileId,
    showWelcomeCard,
    error,
    cardIndex,
    cardResponses,
    deployStatus,
    cardTemplates,
    isLoading,
    formData,
    isSaving,
    lastSavedAt,
    showFullTimeline,
    setShowFullTimeline,
    handleStartDeployment,
    handleInputChange,
    handleSubmitAnswer,
    handleStageCompletion,
    handleSkipStage,
    handleGoBack,
    handleStartSubsteps,
    isStageCompleted,
    isSubstepCompleted,
    getSubstepValue,
    isCurrentStageInProgress,
    getNextIncompleteStageIndex,
    isNextIncompleteStage
  } = useAppStatusLogic();

  // Handle starting substeps (e.g., in the "Closed Testing" stage)
  const handleStartSubstepsClick = async (stageId) => {
    setStartSubstepsLoading(true);
    try {
      await handleStartSubsteps(stageId);
    } finally {
      setStartSubstepsLoading(false);
    }
  };

  return (
    <AppStatusView
      fileId={fileId}
      showWelcomeCard={showWelcomeCard}
      error={error}
      cardIndex={cardIndex}
      cardTemplates={cardTemplates}
      deployStatus={deployStatus}
      isLoading={isLoading}
      formData={formData}
      isSaving={isSaving}
      lastSavedAt={lastSavedAt}
      onStartDeployment={handleStartDeployment}
      onNextCard={handleSkipStage}
      onPrevCard={handleGoBack}
      onStartSubsteps={handleStartSubstepsClick}
      startSubstepsLoading={startSubstepsLoading}
      onInputChange={handleInputChange}
      onSubmitAnswer={handleSubmitAnswer}
      onStageComplete={handleStageCompletion}
      isStageCompleted={isStageCompleted}
      isSubstepCompleted={isSubstepCompleted}
      isCurrentStageInProgress={isCurrentStageInProgress}
      getNextIncompleteStageIndex={getNextIncompleteStageIndex}
      isNextIncompleteStage={isNextIncompleteStage}
      showFullTimeline={showFullTimeline}
      onToggleTimeline={() => setShowFullTimeline(prev => !prev)}
    />
  );
};

export default AppStatusPage; 